import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/orders/overview/filters/Index'
import PharmaciesTopSales from '../../containers/orders/overview/charts/PharmaciesTopSales'
import PaymentsTypes from '../../containers/orders/overview/charts/PaymentsTypes'

import TodaysOrdersFinished from '../../containers/orders/overview/widgets/TodaysOrdersFinished'
import TodaysOrdersCheckout from '../../containers/orders/overview/widgets/TodaysOrdersCheckout'
import TodaysOrdersCanceled from '../../containers/orders/overview/widgets/TodaysOrdersCanceled'
import TodaysOrdersOpenGMV from '../../containers/orders/overview/widgets/TodaysOrdersOpenGMV'
import TodaysOrdersFailed from '../../containers/orders/overview/widgets/TodaysOrdersFailed'

import GrossRevenue from '../../containers/orders/overview/widgets/GrossRevenue'
import OpenGMV from '../../containers/orders/overview/widgets/OpenGMV'
import CommissionRevenue from '../../containers/orders/overview/widgets/CommissionRevenue'
import PaymentsTypesHistory from '../../containers/orders/overview/charts/PaymentsTypesHistory'
// import OrdersFailedFraud from '../../containers/orders/overview/charts/OrdersFailedFraud'
import CancelationReason from '../../containers/orders/overview/charts/CancellationReason'
import SalesTotalsHistory from '../../containers/orders/overview/charts/SalesTotalsHistory'

import OrdersByCity from '../../containers/orders/overview/charts/OrdersByCity'
import GmvDay from '../../containers/orders/overview/charts/GmvDay'
import OrdersHistory from '../../containers/orders/overview/charts/OrdersHistory'
import SalesAverageHistory from '../../containers/orders/overview/charts/SalesAverageHistory'
import OrdersByState from '../../containers/orders/overview/charts/OrdersByState'
import OrdersByPeriod from '../../containers/orders/overview/charts/OrdersByPeriod'
import ShippingStorePickup from '../../containers/orders/overview/charts/ShippingStorePickup'

import OrdersDevice from '../../containers/orders/overview/charts/OrdersDevice'
// import PaymentsMethod from '../../containers/orders/overview/charts/PaymentsMethod'
// import CategoryMostSaled from '../../containers/orders/overview/charts/CategoryMostSaled'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Index = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <Grid item container spacing={1} justifyContent="space-between" className={classes.container}>
        <Grid item sm={12} md={12}>
          <GrossRevenue />
        </Grid>
      </Grid>

      <Grid item container spacing={1} justifyContent="space-between" className={classes.container}>
        <Grid item sm={12} md={6}>
          <OpenGMV />
        </Grid>
        <Grid item sm={12} md={6}>
          <CommissionRevenue />
        </Grid>
      </Grid>

      <div className={classes.container}>
        <Filters />
      </div>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={4}>
          <TodaysOrdersFinished />
        </Grid>
        <Grid item sm={12} md={4}>
          <TodaysOrdersOpenGMV />
        </Grid>
        <Grid item sm={12} md={4}>
          <TodaysOrdersCheckout />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item sm={12} md={6}>
          <TodaysOrdersFailed />
        </Grid>
        <Grid item sm={12} md={6}>
          <TodaysOrdersCanceled />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <OrdersHistory />
        </Grid>
      </Grid>
      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <GmvDay />
        </Grid>
      </Grid>
      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <SalesTotalsHistory />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <SalesAverageHistory />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={6} xs={12}>
          <OrdersByState />
        </Grid>
        <Grid item lg={6} xs={12}>
          <PharmaciesTopSales />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <OrdersByCity />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <CancelationReason />
        </Grid>
      </Grid>

      {/* <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={6} md={12} xs={12}>
          <PaymentsTypes />
        </Grid>
        <Grid item lg={6} md={12} xs={12}>
          <OrdersFailedFraud />
        </Grid>
      </Grid> */}

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
          <PaymentsTypes />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <PaymentsTypesHistory />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
          <OrdersByPeriod />
        </Grid>
      </Grid>
      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
          <ShippingStorePickup />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={12} md={12} xs={12}>
          <OrdersDevice />
        </Grid>
      </Grid>

      {/* <Grid item container spacing={1} className={classes.container}>
        <Grid item lg={6} md={12} xs={12}>
          <PaymentsMethod />
        </Grid>
        <Grid item lg={6} md={12} xs={12}>
          <CategoryMostSaled />
        </Grid>
      </Grid> */}
    </MainTemplate>
  )
}

export default Index
